/**
 * Samweb WebClient
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { QueryCallTagsForCallResponseData } from '../model/queryCallTagsForCallResponseData';
import { SpecificMessageTagRequestData } from '../model/specificMessageTagRequestData';
import { SpecificMessageTagResponseData } from '../model/specificMessageTagResponseData';
import { UpdateCallTagRequestData } from '../model/updateCallTagRequestData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CallTagsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param uniqueCallId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryCallTagForCall(uniqueCallId?: string, observe?: 'body', reportProgress?: boolean): Observable<QueryCallTagsForCallResponseData>;
    public queryCallTagForCall(uniqueCallId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QueryCallTagsForCallResponseData>>;
    public queryCallTagForCall(uniqueCallId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QueryCallTagsForCallResponseData>>;
    public queryCallTagForCall(uniqueCallId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (uniqueCallId !== undefined && uniqueCallId !== null) {
            queryParameters = queryParameters.set('uniqueCallId', <any>uniqueCallId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<QueryCallTagsForCallResponseData>('get',`${this.basePath}/api/call-tags/call-tags-for-call`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public specificMessageTag(body?: SpecificMessageTagRequestData, observe?: 'body', reportProgress?: boolean): Observable<SpecificMessageTagResponseData>;
    public specificMessageTag(body?: SpecificMessageTagRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SpecificMessageTagResponseData>>;
    public specificMessageTag(body?: SpecificMessageTagRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SpecificMessageTagResponseData>>;
    public specificMessageTag(body?: SpecificMessageTagRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SpecificMessageTagResponseData>('post',`${this.basePath}/api/call-tags/specific-message-tag`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCallTag(body?: UpdateCallTagRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateCallTag(body?: UpdateCallTagRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateCallTag(body?: UpdateCallTagRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateCallTag(body?: UpdateCallTagRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/call-tags/call-tag`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
